(function () {
  var section = document.querySelector('[data-lbr-pdp]');
  if (!section) return;

  /* ===== Galerie ===== */
  var galleryMain = section.querySelector('[data-lbr-gallery-main]');
  var thumbs = section.querySelectorAll('[data-lbr-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = parseInt(thumb.dataset.lbrThumb, 10);
      var slide = section.querySelector('[data-lbr-slide="' + index + '"]');
      if (slide && galleryMain) {
        galleryMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  if (galleryMain) {
    galleryMain.addEventListener('scroll', function () {
      var scrollLeft = galleryMain.scrollLeft;
      var width = galleryMain.clientWidth;
      var index = Math.round(scrollLeft / width);
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
      });
    });
  }

  /* ===== Description "voir plus" ===== */
  var descToggle = section.querySelector('[data-lbr-description-toggle]');
  var desc = section.querySelector('[data-lbr-description]');
  if (descToggle && desc) {
    descToggle.addEventListener('click', function () {
      var expanded = desc.classList.toggle('is-expanded');
      descToggle.textContent = expanded ? 'Voir moins' : 'Voir plus';
    });
  }

  /* ===== Variantes ===== */
  var variantButtons = section.querySelectorAll('[data-lbr-variant]');
  var addBtn = section.querySelector('[data-lbr-add-to-cart]');
  var addPriceEl = section.querySelector('[data-lbr-add-price]');

  variantButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      variantButtons.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      if (addBtn) addBtn.dataset.variantId = btn.dataset.variantId;
      if (addPriceEl) addPriceEl.textContent = btn.dataset.priceFormatted;
    });
  });

  /* ===== Ajout panier ===== */
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.classList.contains('is-loading') || addBtn.disabled) return;
      var variantId = addBtn.dataset.variantId;
      if (!variantId) return;

      var label = addBtn.querySelector('[data-lbr-add-label]');
      var originalText = label ? label.textContent : '';

      addBtn.classList.add('is-loading');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-added');
          if (label) label.textContent = 'Ajouté !';

          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count-bubble').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            });

          try {
            var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              var cartIcon = document.querySelector('#cart-icon-bubble, [data-cart-icon], a[href="/cart"]');
              if (cartIcon) cartIcon.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
          } catch (e) {}

          setTimeout(function () {
            addBtn.classList.remove('is-added');
            if (label) label.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          if (label) label.textContent = originalText;
        });
    });
  }
})();